import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { ANNUALIZED_MFR_GMV_BRANDS } from 'lib/networking/endpoints';

/**
 * useMfrBrands — brands of a manufacturer ordered by GMV (MSV mfr-detail grid).
 *
 * Hits GET /annualized-mfr-gmv/brands (params: manufacturer_id, limit, offset,
 * search, l1_category_id, l2_category_id, distributor_id).
 *
 * Returns { data: { brands: [], count }, loading, error, refetch }.
 */
function useMfrBrands({
  manufacturerId,
  offset = 0,
  limit = 50,
  searchQuery,
  l1CategoryId,
  l2CategoryId,
  distributorId,
  thirdPartyTag,
  skip = false,
} = {}) {
  const trimmed = (searchQuery || '').trim();
  const params = useMemo(() => {
    const p = { manufacturer_id: manufacturerId, offset, limit };
    if (trimmed) p.search = trimmed;
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (l2CategoryId) p.l2_category_id = l2CategoryId;
    if (distributorId) p.distributor_id = distributorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    return p;
  }, [
    manufacturerId,
    offset,
    limit,
    trimmed,
    l1CategoryId,
    l2CategoryId,
    distributorId,
    thirdPartyTag,
  ]);

  return useGet(ANNUALIZED_MFR_GMV_BRANDS, params, skip || !manufacturerId);
}

export default useMfrBrands;
